
<div style="position:relative;">
    <c-card-iterator
        :items          = "filteredItems"
        :label          = "title"
        :loading        = "loading"
        :title-prefix   = "true"
        :item-height    = "76"
        :min-height     = "topHeight"
        :filter         = "match"
        :filter-height  = "72"
        :height         = "height"
        @search         = "onSearch"
    >
        <template v-slot:card="{ item }">
            <p-inc-open-incident-card
                :item = "item"
            />
        </template>
    </c-card-iterator>

    <div v-if="(!items || items.length === 0) && !loading" class="lm-border empty-todos">
        <v-icon color="success" size="30">mdi-check-circle</v-icon>
    </div>
</div>
